import {CaseProcedureViewDataModel} from '../caseProcedures/case-procedure-view-data.model';
import {PatientCaseDataModel} from './patient-case-data.model';
import {ToothConfigurationModel} from '../teeth/tooth-configuration.model';
import {DocumentPseudoPatientCaseWorkItemToothDataModel} from '../document/document-pseudo-patient-case-work-item-tooth-data.model';

export class PatientCaseViewDataModel {
  Case: PatientCaseDataModel;
  PatientCaseId: string;
  PatientId: string;
  Description: string;
  DateString: string;
  Created: Date;
  Teeth: string;
  TeethList: string[];
  TeethIdsList: string[];
  DataTeethIdsList: DocumentPseudoPatientCaseWorkItemToothDataModel[];
  CaseProcedures: CaseProcedureViewDataModel[];

  TeethConfigurations: ToothConfigurationModel[] = [];
  DoctorId: string;
  ProcedureName: string;
  isRecall: boolean;

  // Frontend only
  isExpanded = false;

}
